export default {
    'InsertUnameEmail':     'Insérez le nom d’utilisateur ou l’adresse',
    'ChangePass':           'Changez le mot de passe',
    'UnameOrEmail':         'Nom d’utilisateur ou e-mail',
    'PassRecover':          'Récupérez le mot de passe',
    'InsertCurrPass':       'Insérez le nouveau mot de passe',
    'CurrentPass':          'Mot de passe actuel',
    'NewPass':              'Nouveau mot de passe',
    'CreateNewPass':        'Choisissez un nouveau mot de passe',
    'ConfirmNewPass':       'Confirmez le nouveau mot de passe',
    'show_pass':            'Montrez le mot de passe',
    'hide_pass':            'Masquez le mot de passe',
    'RequiredField':        'Champ obligatoire',
    'PassDontMatch':        'Le nouveau mot de passe et sa confirmation doivent être identiques',
    'PassReq1':             'Il ne peut pas être trop commun',
    'PassReq2':             'Il doit contenir au moins 12 caractères',
    'PassReq3':             'Il ne peut pas être composé uniquement de chiffres',
    'SuccessMailSent':      'Nous avons envoyé un e-mail à l’utilisateur ou à l’adresse e-mail indiquée. Suivez les instructions jointes pour créer un nouveau mot de passe',
    'SuccessMailSent2':     'Si vous ne l’avez pas reçu, contactez l’assistance technique',
    'SuccessPassReset':     'Le mot de passe a été mis à jour avec succès',
    'Send':                 'Envoyez',
    'UnknownError':         'Une erreur imprévue s’est produite. Réessayez plus tard.',
    'Language':             'Langue'
}
